




















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ChartsService, ChartsViewModel, ChartsNodeViewModel, ChartsLinkViewModel, ChartsNodeService, ChartsLinkService } from '../../api/charts';
import { TimelineItemService, TimelineItemViewModel } from '../../api/timelineItem';
import FavoriteButton from '../Favorite/FavoriteButton.vue';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/polar';
import 'echarts/lib/chart/graph';

@Component({
  components: {
    FavoriteButton,
    'v-chart': ECharts,
  },
})
export default class ChartsDemo extends Vue {
  private chartsService: ChartsService = new ChartsService();
  private nodeService: ChartsNodeService = new ChartsNodeService();
  private linkService: ChartsLinkService = new ChartsLinkService();
  private chartsData: ChartsViewModel = this.chartsService.NewModel;
  private node: ChartsNodeViewModel = this.nodeService.NewModel;
  private link: ChartsLinkViewModel = this.linkService.NewModel;
  private nodeData: any[] = [];
  private nodeDetailData: any[] = [];
  private linkData: any[] = [];
  private currentNodeId: number = 0;
  private chartsId: number = 0;

  private timelineItemService: TimelineItemService = new TimelineItemService();
  private timelineItemData: any[] = [];
  private timelineItemIndex!: number;
  private loading: boolean = false;

  private graphHeight: string = '500px';
  private showDrawer: boolean = true;
  private nodeName: string = '';
  // private linkData: any = {
  //   source: '',
  //   target: '',
  //   name: '',
  // };
  // private node: any[] = [
  //   {
  //     name: 'test1',
  //     symbolSize: 50,
  //     symbol: 'circle',
  //     draggable: true,
  //   },
  //   {
  //     name: 'test2',
  //     symbolSize: 50,
  //     symbol: 'circle',
  //     draggable: true,
  //   },
  // ];
  // private link: any[] = [
  //   {
  //     // source: 'test1',
  //     // target: 'test2',
  //     source: 0,
  //     target: 1,
  //     curveness: 0.5,
  //   },
  // ];
  private polar: any = {
    title: {
      text: this.chartsData.name,
    },
    edgeSymbol: ['circle', 'arrow'],
    edgeSymbolSize: [4, 10],
    edgeLabel: {
        normal: {
            textStyle: {
                fontSize: 20,
            },
        },
    },
    series: [
      {
        name: 'Les Miserables',
        type: 'graph',
        layout: 'force',
        data: this.nodeData,
        links: this.linkData,
        roam: true,
        label: {
            normal: {
                position: 'inside',
                show: true,
            },
        },
        force: {
          repulsion: 300,
          edgeLength: 150,
            // repulsion: 500,
            // gravity: 0.1,
            // layoutAnimation: truncate,
        },
        lineStyle: {
          normal: {
            opacity: 0.9,
            width: 2,
            curveness: 0,
          },
        },
      },
    ],
    animationDuration: 2000,
  };

  private created() {
    this.graphHeight = window.innerHeight + 'px';
  }

  private mounted() {
    this.chartsId = parseInt(this.$route.query.id + '');
    if (this.chartsId > 0) {
      this.loadData(this.chartsId);
    }
  }

  private loadData(id: number) {
    this.chartsService.Get(id).then((response: any) => {
      this.chartsData = response;
    });
    this.nodeService.GetByChartsId(id).then((resposne: any) => {
      // console.log(resposne);
      const initData: any[] = [];
      for (const item of resposne) {
        const newNode = {
          id: item.id,
          name: item.id.toString(),
          symbolSize: 50,
          symbol: 'circle',
          draggable: true,
          extra: item,
          label: {
            formatter: item.name,
          },
        };
        // initData.push(newNode);
        this.nodeData.push(newNode);
      }
      // console.log(initData);
      // this.nodeData = initData;
      // this.nodeData.push(initData);
      // console.log(this.nodeData);
      // this.timelineItemIndex = 0;
    });
    this.nodeService.GetTimelineItem(id).then((response: any) => {
      this.nodeDetailData = response;
    });
    this.linkService.GetByChartsId(id).then((response: any) => {
      for (const item of response) {
        const newLink = {
          id: item.id,
          source: item.source.toString(),
          target: item.target.toString(),
          label: {
            normal: {
              show: true,
              formatter: item.name,
            },
          },
          lineStyle: {
            normal: {
            curveness: item.curveness,
            },
          },
          extra: item,
        };
        this.linkData.push(newLink);
      }
    });
  }

  private timelineItem_OnSearch(query: string) {
    if (query !== '') {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.timelineItemService.GetByName(query).then((response: any) => {
          this.timelineItemData = response;
        });
        // this.options = this.list.filter(item => {
        //   return item.label.toLowerCase()
        //     .indexOf(query.toLowerCase()) > -1;
        // });
      }, 200);
    } else {
      this.timelineItemData = [];
    }
  }

  private btnSaveNode_OnClick() {
    // this.node.push({
    //   name: this.nodeName,
    //   symbolSize: 50,
    //   symbol: 'circle',
    //   draggable: true,
    // });
    // console.log(this.node);
    // this.nodeName = '';
    const node: ChartsNodeViewModel = {
      chartsID: this.chartsId,
      timelineItemID: this.timelineItemData[this.timelineItemIndex].id,
      name: this.timelineItemData[this.timelineItemIndex].name,
      color: '',
      size: 50,
    };
    this.nodeService.Create(node).then((response: any) => {
      const newNode = {
        id: response.id,
        name: response.id!.toString(),
        symbolSize: 50,
        symbol: 'circle',
        draggable: true,
        extra: response,
        label: {
          formatter: node.name,
        },
      };
      this.nodeData.push(newNode);
    });
    console.log(this.timelineItemIndex);
  }
  private btnSaveLink_OnClick() {
    console.log(this.linkData);
    this.link.chartsID = this.chartsId;
    this.link.curveness = 0;
    this.link.width = 1;
    this.linkService.Create(this.link).then((response: any) => {
      const newLink = {
        id: response.id,
        source: this.link.source,
        target: this.link.target,
        label: {
          normal: {
            show: true,
            formatter: this.link.name,
          },
        },
        lineStyle: {
          normal: {
          curveness: this.link.curveness,
          },
        },
        extra: response,
      };
      this.linkData.push(newLink);
    });
    // this.linkData.lineStyle = {
    //   normal: {
    //      curveness: 0.5,
    //   },
    // };

    // this.link.push(newLink);
    // this.linkData = {
    //   source: '',
    //   target: '',
    // };
  }

  private chart_OnClick(params: any) {
    if (params.dataType === 'edge') {
      this.link = params.data.extra;
    } else if (params.dataType === 'node') {
      console.log(params);
      this.node = params.data.extra;
      this.currentNodeId = this.node.timelineItemID!;
      this.timelineItemService.Get(this.node.timelineItemID!).then((response: any) => {
        this.timelineItemData = [];
        this.timelineItemData.push(response);
        this.timelineItemIndex = 0;
      });
    }
  }
}
